<div class="container-fluid">

  <app-loader *ngIf="isLoading()"></app-loader>

  <div class="page" *ngIf="!isLoading()">

    <div class="page-body">

      <div class="container-section">

        <div class="container-smaller">

          <div class="content">

            <div class="entity-single">

              <div class="row">
                <div class="col-12 col-sm-6">
                  <h2 class="page-title entity-title mb-3">
                    {{ getTranslatedTitle() }}
                  </h2>
                </div>
              </div>

              <div class="row">

                <div class="col-12 col-sm-6">

                  <span class="ck-content" [innerHTML]="getTranslatedContent() | safeHtml"></span>

                </div>

                <div class="col-12 col-sm-6">

                  <!-- form -->
                  <form [formGroup]="contactForm" (submit)="onSubmitContactForm()" class="form">

                    <div class="form-group">
                      <input class="form-control" formControlName="fullName" placeholder="{{ 'Name' | translate }}*" />
                    </div>

                    <div class="form-group">
                      <input class="form-control" formControlName="emailAddress" placeholder="{{ 'Email' | translate }}*" />
                    </div>

                    <div class="form-group">
                      <input class="form-control" formControlName="phoneNumber" placeholder="{{ 'Phone number' | translate }}*" />
                    </div>

                    <div class="form-group">
                      <input class="form-control" formControlName="subject" placeholder="{{ 'Subject' | translate }}" />
                    </div>

                    <div class="form-group">
                      <textarea rows="3" class="form-control" formControlName="contactFormMessage" placeholder="{{ 'Your message' | translate }}"></textarea>
                    </div>

                    <div class="d-flex">
                      <button class="btn btn-primary flex-grow-1" type="button" (click)="onSubmitContactForm()">{{ 'Send' | translate }}</button>
                    </div>

                    <div *ngIf="formSubmitted && !formError" class="alert alert-success">
                      {{ 'Thanks for your message, we will respond as soon as possible!' | translate }}
                    </div>

                    <div *ngIf="formSubmitted && formError" class="alert alert-danger">
                      {{ 'Please fill in all required fields' | translate }}
                    </div>

                  </form>

                </div>

              </div>

            </div>


          </div>


        </div>

      </div>

    </div>

  </div>

</div>
